export default "__VITE_ASSET__gjMYMZpI__"